export const fields = [
  {
    identifier: 'email',
    label: 'email',
    rules: [
      { required: true, message: 'من فضلك أدخل البريد الإلكتروني' },
      { type: 'email', message: 'صيغة البريد الإلكتروني غير صحيحة' },
    ],
    placeholder: 'email-placeholder',
    type: 'input',
  },
  {
    identifier: 'password',
    label: 'password',
    rules: [{ required: true, message: 'من فضلك أدخل كلمة المرور' }],
    placeholder: 'password-placeholder',
    type: 'password',
  },
  {
    identifier: 'remember',
    valuePropName: 'checked',
    type: 'checkbox',
    customValue: 'remember',
  },
];
